import { produce } from 'immer';

import * as Types from './types';
import { actionTypes } from './constants';

export const defaultState: Types.ISessionState = {
    enabled: true,
    sessionDuration: 0,
    sessionLimit: null,
    sessionTimoutShown: false
};

export const reducer = produce((draftState, action: Types.TSessionAction): Types.ISessionState | void => {
    switch (action.type) {
        case actionTypes.SET_SESSION_DURATION: {
            Object.assign(draftState, {
                sessionDuration: action.payload
            });

            break;
        }

        case actionTypes.SET_SESSION_ENABLED: {
            Object.assign(draftState, {
                enabled: action.payload
            });

            break;
        }

        case actionTypes.SET_SESSION_LIMIT: {
            Object.assign(draftState, {
                sessionLimit: action.payload
            });

            break;
        }

        case actionTypes.SET_SESSION_TIMEOUT_SHOWN: {
            Object.assign(draftState, {
                sessionTimoutShown: action.payload
            });

            break;
        }

        default:
            break;
    }
}, defaultState);
